<template>
  <a @click="$router.go(-1)" class="action-button">
    <button class="btn-info action-button">
      <i
        class="fa-wrapper fa fa-reply normal-icon pad-right"
        aria-hidden="true"
      ></i>
      Back
    </button>
  </a>
</template>
<script>
export default {
  name: "back-button",
}
</script>
